import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import logo from '@/imgs/logo.png'

interface LoadingScreenProps {
  onRefresh?: () => void
}
export function LoadingScreen({ onRefresh }: LoadingScreenProps) {
  const { t } = useTranslation()
  return (
    <div className='bg-background-app flex min-h-dvh w-full items-center justify-center p-6'>
      <div className='m-auto flex h-[600px] w-[300px] flex-col items-center justify-between gap-6'>
        <img src={logo} alt='logo' className='h-auto w-48' />
        <div className='flex flex-col items-center gap-4'>
          <Spinner className='h-12 w-12' />
          <p className='text-lg font-medium text-gray-900'>{t('common.loading')}</p>
        </div>
        {onRefresh && (
          <Button onClick={onRefresh} variant='default' size='lg'>
            {t('common.backToHome')}
          </Button>
        )}
      </div>
    </div>
  )
}
